import type { PairedRunner } from '../../services/runner-pairing.service';

/**
 * Nur der eigene bevorzugte Rechner wird vorbelegt, und nur eingeschaltet: Der alphabetisch erste
 * waere womoeglich der Laptop einer Kollegin, und ein ausgeschalteter nimmt nichts an.
 */
export function preselect(
  runners: readonly PairedRunner[],
  selectable: (runner: PairedRunner) => boolean = (runner) => runner.online,
): string | null {
  return runners.find((runner) => runner.preferred && selectable(runner))?.id ?? null;
}

/**
 * Etiketten ausgeschalteter Rechner fehlen: Der Server nimmt nur an, was ein verbundener Rechner
 * traegt — der Eintrag fuehrte sicher in die Absage.
 */
export function labelOptions(runners: readonly PairedRunner[]): string[] {
  const labels = new Set<string>();
  for (const runner of runners) {
    if (runner.online) {
      [...runner.reportedLabels, ...runner.managedLabels].forEach((label) => labels.add(label));
    }
  }
  return [...labels].sort();
}
